import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Notary from './Notary';
import Heading from '../common/Heading';
import portraitLindenmaier from '../../images/portrait-mark-lindenmaier.jpg';
import portraitLuz from '../../images/portrait-yvonne-luz.jpg';

const Notaries = () => {
  return (
    <div className='notaries' id='notaries'>
      <Heading heading='Notarin' />

      <Container>
        <Row>
          <Col xs={12} md={6} lg={5}>
            <Notary
              src={portraitLuz}
              description='Notarin'
              name='Yvonne Luz'
              alt="Portrait von Yvonne Luz im schwarzen Anzug und weißem Hemd."
              button={{
                variant: 'primary',
                text: 'Biografie',
              }}
              biography={{
                text1: {
                  year: 'seit 2018',
                  text: 'öffentliche Notarin in Stuttgart Bad Cannstatt als Amtsnachfolgerin von Notar Ernst Weinmann',
                },
                text2: {
                  year: '2016 - 2017',
                  text: 'Notarin im Landesdienst beim Notariat Stuttgart Feuerbach',
                },
                text3: {
                  year: '2015 - 2021',
                  text: 'ehrenamtlich 2. Vorsitzende des Württembergischen Notarvereins e.V.',
                },
                text4: {
                  year: '2009 - 2016',
                  text: 'Notarin im Landesdienst beim Notariat Fellbach (Schmiden und Oeffingen)',
                },
                text5: {
                  year: '2000 – 2009',
                  text: 'Notarvertreterin im Landesdienst bei den Notariaten Winnenden, Backnang, Vaihingen/Enz, Ludwigsburg und Fellbach (Schmiden und Oeffingen)',
                },
                text6: {
                  year: '1997 - 2000',
                  text: 'Württ. Notariatsassessorin bei einem öffentlichen Notar in Stuttgart',
                },
                text7: {
                  year: '1997',
                  text: 'Notarprüfung',
                },
              }}
            />
          </Col>
          <Col xs={12} md={6} lg={{ span: 5, offset: 2 }}>
            <Notary
              src={portraitLindenmaier}
              description='Notar a. D.'
              name='Mark Lindenmaier'
              alt="Portrait von Mark Lindenmaier im schwarzen Anzug, weißem Hemd und roter Krawatte."
              button={{
                variant: 'primary',
                text: 'Biografie',
              }}
              biography={{
                text1: {
                  year: 'seit 2007',
                  text: 'öffentlicher Notar in Stuttgart Bad Cannstatt als Amtsnachfolger von Notar Albrecht Majerle (früher Seelbergstraße 15, 70372 Stuttgart Bad Cannstatt)',
                },
                text2: {
                  year: '2000 - 2007',
                  text: 'Notar bei den Notariaten Winterbach und Waiblingen, zuletzt dienstaufsichtsführender Notar',
                },
                text3: {
                  year: '2000 - 2006',
                  text: 'Referent der Gemeinsamen DV-Stelle Justiz beim OLG Stuttgart',
                },
                text4: {
                  year: '1993 - 1999',
                  text: 'Notarvertreter im Landesdienst beim Oberlandesgericht Stuttgart',
                },
                text5: {
                  year: '1994 - 1998',
                  text: 'Geschäftsführer der Notarkammer Stuttgart (heute Notarkammer Baden-Württemberg)',
                },
                text6: {
                  year: '1991 - 1992',
                  text: 'Württ. Notariatsassessor in großer Rechtsanwalts- und Notarkanzlei in Stuttgart und Berlin',
                },
                text7: {
                  year: '1990',
                  text: 'Notarprüfung',
                },
              }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Notaries;
